import * as types from '../const/action.types';

export function provider(state = {}, action) {
    switch (action.type) {
        case types.LOAD_PROVIDER_SUCCESS:
            return action.data;
        case types.LOG_OUT:
            return {};
        default:
            return state;
    }
}

export function providers(state = [], action) {
    switch (action.type) {
        case types.PROVIDERS_SUCCESS:
            return action.data;
        default:
            return state;
    }
}

export function providersHasErrored(state = { hasErrored: false, error: '' }, action) {
    switch (action.type) {
        case types.PROVIDER_HAS_ERROR:
            return {
                hasErrored: action.hasErrored,
                error: action.error,
            };

        default:
            return state;
    }
}

export function providersIsLoading(state = false, action) {
    switch (action.type) {
        case types.PROVIDERS_IS_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/providers.reducer.js